module.exports = __webpack_public_path__ + "media/question7_en.a808256c.mp3";